module.exports = __webpack_public_path__ + "34e0e1790b69794670307daf5b0f5fb7.fbx";